import React, { Component } from 'react'

import { FillerInlineDiv } from '../StyledComponents/Fillers'
import { SettingsInputMail, SettingsTitle, SettingsRow } from '../StyledComponents/Settings'

class SettingsRowEmail extends Component {
    constructor(props) {
        super(props)

        this.onValueChange = this.onValueChange.bind(this)
    }

    onValueChange(e) {
        this.props.handleChange(e.target.value)
    }

    render() {
        const {
            title,
            placeholder,
            currentValue,
            disabled,
        } = this.props

        if (disabled) {
            return null
        }

        return (
            <SettingsRow>
                <SettingsTitle className="align-top col-6">{title}</SettingsTitle>
                <FillerInlineDiv className="col-6 text-right">
                    <SettingsInputMail value={currentValue} onChange={this.onValueChange} placeholder={placeholder} type="email" />
                </FillerInlineDiv>
            </SettingsRow>
        )
    }
}

SettingsRowEmail.defaultProps = {
    placeholder: 'Email Adresse',
}

export default SettingsRowEmail



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsRowEmail.js